import Vue from 'vue';
export const EventBus = new Vue({
    methods: {
        busesAreLoaded(areLoaded) {
            this.$emit('BusesAreLoaded', areLoaded);
        },
        bookingsAreLoaded(areLoaded) {
            this.$emit('BookingsAreLoaded', areLoaded);
        },
        busIdChange(busId) {
            this.$emit('busIdChange', busId);
        },
        optionChanged() {
            this.$emit('optionChanged');
        }
    }
});